// Single source of truth for all calculator routes.
// Used by Footer.tsx and Sidebar.tsx — add new calculators here only.

export const CALCULATORS: { name: string; path: string; icon?: string }[] = [
  { name: 'Blob Storage',         path: '/blob-storage',    icon: 'folder_open' },
  { name: 'Logic Apps',           path: '/logic-apps',      icon: 'account_tree' },
  { name: 'Azure Functions',      path: '/functions',       icon: 'bolt' },
  { name: 'App Service',          path: '/app-service',     icon: 'web' },
  { name: 'Azure Kubernetes Service', path: '/aks',          icon: 'lan' },
  { name: 'Bandwidth & Egress',   path: '/bandwidth',       icon: 'swap_horiz' },
  { name: 'Azure Firewall',       path: '/firewall',        icon: 'shield' },
  { name: 'Networking',           path: '/networking',      icon: 'hub' },
  { name: 'Azure Front Door',      path: '/front-door',      icon: 'public' },
  { name: 'Application Gateway',   path: '/application-gateway', icon: 'call_split' },
  { name: 'VPN Gateway',           path: '/vpn-gateway',         icon: 'vpn_key' },
  { name: 'Azure Bastion',         path: '/bastion',             icon: 'screen_share' },
  { name: 'Log Analytics',        path: '/log-analytics',   icon: 'monitor_heart' },
  { name: 'Virtual Machines',     path: '/virtual-machines',icon: 'computer' },
  { name: 'Data Factory',         path: '/data-factory',    icon: 'schema' },
  { name: 'Azure Virtual Desktop', path: '/virtual-desktop', icon: 'desktop_windows' },
  { name: 'SQL Database',        path: '/sql-database',    icon: 'database' },
  { name: 'SQL Managed Instance', path: '/sql-managed-instance', icon: 'database' },
  { name: 'Azure OpenAI',        path: '/azure-openai',    icon: 'smart_toy' },
  { name: 'Azure Managed Disks',  path: '/managed-disks',   icon: 'storage' },
  { name: 'Key Vault',           path: '/key-vault',        icon: 'lock' },
  { name: 'Azure DevOps',        path: '/azure-devops',     icon: 'code' },
  { name: 'Azure Backup',        path: '/azure-backup',     icon: 'shield_backup' },
  { name: 'Site Recovery',       path: '/site-recovery',    icon: 'cloud_sync' },
]
